"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _KYC = _interopRequireDefault(require("../KYC"));
var _KYC_ManualLevelsContainer = _interopRequireDefault(require("./KYC_ManualLevelsContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var KYC_ManualComponent = function KYC_ManualComponent() {
  return /*#__PURE__*/_react["default"].createElement(_KYC["default"], {
    LevelsComponent: _KYC_ManualLevelsContainer["default"]
  });
};
var _default = exports["default"] = KYC_ManualComponent;